import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[appModalDialogSlot]'
})
export class ModalDialogSlotDirective {
    constructor(public viewContainerRef: ViewContainerRef) {}
}
